import { Button } from 'antd'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'

import Google from '../svgs/auth/Google'
import { getPostAuthRedirectPath } from '@/utils/authRedirect'
// import Facebook from '../svgs/auth/Facebook'

const DEV_AUTH_URL = 'https://backend-dev.smartcaf.it/auth/google'
const PROD_AUTH_URL = 'https://backend.smartcaf.it/auth/google'

const getGoogleAuthUrl = () => {
  if (typeof window !== 'undefined') {
    const isLocalhost = ['localhost', '127.0.0.1'].includes(window.location.hostname)

    if (isLocalhost) {
      return DEV_AUTH_URL
    }
  }

  const configuredHost = process.env.NEXT_PUBLIC_HOST

  if (configuredHost) {
    try {
      return `${new URL(configuredHost).origin}/auth/google`
    } catch (error) {
      // Ignore malformed host config and fall back to the environment switch below.
    }
  }

  return process.env.NEXT_PUBLIC_ENVIRONMET === 'development'
    ? DEV_AUTH_URL
    : PROD_AUTH_URL
}

const SocialButtons = () => {
  const { t } = useTranslation('HomeLayout')
  const { query } = useRouter()

  const handleGoogleLogin = () => {
    const nextRedirectPath = getPostAuthRedirectPath(query.redirection_link)

    if (nextRedirectPath) {
      localStorage.setItem('redirection_link', nextRedirectPath)
    }

    window.open(getGoogleAuthUrl(), '_self')
  }

  return (
    <>
      <div className='flex justify-center gap-12'>
        <Button
          className='social-login !w-full'
          onClick={handleGoogleLogin}
        >
          <Google style='w-20' /> Google
        </Button>
        {/* <Button
          className='social-login'
          onClick={() => {
            if (process.env.NEXT_PUBLIC_ENVIRONMET === 'development') {
              window.open('https://backend-dev.smartcaf.it/auth/google', '_self')
            } else {
              window.open('https://backend.smartcaf.it/auth/google', '_self')
            }
          }}
        >
          <Facebook style='w-20' /> Facebook
        </Button> */}
      </div>

      <div className='relative w-10/12 mx-auto'>
        <hr className='my-32 border-[#6D6D6D] opacity-30' />
        <span className='bg-white text-[#626d7d] text-sm font-medium absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 py-4 px-16'>
          {t('Or log in with')}
        </span>
      </div>
    </>
  )
}

export default SocialButtons
